import { Globals } from "../CoreApp/Globals";
import { QStdButton } from "../CoreApp/QStdButton";
import { CenterIt } from "./CenterIt";

export function AddStdButtonAutoPos(
  panel,
  xLeft,
  xRight,
  placement,
  minSize,
  yPos,
  height,
  label,
  font,
  fontSize,
  bold,
  cmdCode
) {
  var stdButton = new QStdButton();
  var wsMgr = panel.fWSMgr;
  if (!wsMgr) wsMgr = Globals._wsMgr;
  var uicolors = wsMgr.GetUIColors();
  if (font != null) stdButton.SetFontName(font);
  if (fontSize != null) stdButton.SetFontSize(fontSize);
  stdButton.SetBold(bold);

  stdButton.SetStdFillColor(uicolors.GetButtonFillColor());
  stdButton.SetFontColor(uicolors.GetHeaderTextColor());

  if (xLeft == null) xLeft = 0;

  var availableWidth = xRight - xLeft;
  stdButton.SizeElement(availableWidth - 2, height);
  stdButton.SetLabel(label);

  var width = stdButton.CalcMinWidth();
  if (minSize && width < minSize) width = minSize;

  var xPos;

  switch (placement) {
    case "left":
      xPos = xLeft;
      break;
    case "center":
      xPos = xLeft + CenterIt(availableWidth, width);
      break;
    case "right":
      xPos = xRight - width;
      break;
  }

  stdButton.PositionElement(xPos, yPos);
  stdButton.SizeElement(width, height);
  stdButton.SetCmdCode(cmdCode);
  panel.PushElement(stdButton);

  return stdButton;
}
